import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Card } from "@omni/ui/components/Card/card";
import { cn } from "@omni/utils/styles";

type BaseProps = RequireChildrenFor<{
    className?: string;
}>;

const Base = ({ className, children }: BaseProps) => {
    return (
        <Card className={cn("tw:mb-0", className)}>
            <Card.Body>
                <Card.Text tag="div">{children}</Card.Text>
            </Card.Body>
        </Card>
    );
};

export { Base };
